import React from "react";
import ActionBtn from "./actionBtn/ActionBtn";
import styles from "../Broadcast.module.css";
import { addSeconds, parseISO, format } from "date-fns";
import LoadingPlaceholder from "./loadingPlaceholder/LoadingPlaceholder";
import { BroadcastObject } from "types/broadcast";

interface Props {
	broadcastData: BroadcastObject;
	isLoading: boolean;
}

export default function Info({ broadcastData, isLoading }: Props) {
	const getEndTime = (date: string, increase: string) => {
		const startDate = parseISO(date);
		const returnedEndDate = addSeconds(startDate, Number(increase));
		return returnedEndDate;
	};

	return (
		<section className={styles.broadcastInfo}>
			{!isLoading ? (
				<>
					<div>
						<h1 className="text-body fs-4">{broadcastData.title}</h1>
					</div>
					<div className={styles.broadcastInfoBottom}>
						<span className="text-muted">
							{format(new Date(broadcastData.date), "MMM dd yyyy")}
							<p className={styles.broadcastTime}>
								<span>{format(new Date(broadcastData.date), "hh:mm a")}</span>
								<span>&nbsp;-&nbsp;</span>
								<span>{format(getEndTime(broadcastData.date, broadcastData.expected_duration), "hh:mm a")}</span>
							</p>
						</span>
						<div className={styles.headerButtons}>
							<ActionBtn />
						</div>
					</div>
				</>
			) : (
				<LoadingPlaceholder />
			)}
		</section>
	);
}
